import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { TimesState } from "../../types/types";

const SLICE_NAME = "time";

export const getTime = createAsyncThunk<string[], string>(
  `${SLICE_NAME}/getTime`,
  async (currentDate, { rejectWithValue }) => {
    try {
      const API_URL = process.env.REACT_APP_URL_BACKEND;

      const response = await fetch(
        `${API_URL}/api/v1/orders/?consultation_date=${currentDate}`
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();

      if (!Array.isArray(data)) return [];

      return data
        .filter((item) => !item.is_booked)
        .map((item) => item.consultation_time.slice(0, 5));
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }

      return rejectWithValue("Unknown error occurred");
    }
  }
);

const initialState: TimesState = {
  time: [],
  loading: false,
  error: null,
};

const timeSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTime.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTime.fulfilled, (state, action) => {
        state.loading = false;
        state.time = action.payload ?? [];
      })
      .addCase(getTime.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default timeSlice.reducer;
